import workspaceQuery from '../../queries/purchases/PurchaseCostTemplateWorkspaceQuery.graphql';
import listQuery from '../../queries/purchases/PurchaseCostTemplateListQuery.graphql';
import instanceQuery from '../../queries/purchases/PurchaseCostTemplateQuery.graphql';
import defaultQuery from '../../queries/purchases/PurchaseCostTemplateDefault.graphql';
import mutationQuery from '../../mutations/purchases/PurchaseCostTemplateMutation.graphql';
import fragment from '../../fragments/purchases/PurchaseCostTemplateFragment.graphql';
import { Direction } from '../../schema/p4types';

const PurchaseCostTemplate = {
  type: 'PurchaseCostTemplate',
  title: 'Purchase Costs',
  formTitle: 'Purchase Cost',
  formUrl: '/Purchasing/Cost/Details/',
  workspaceUrl: '/Purchasing/Cost/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
    customVariables: () => {
      return {
        orderBy: 'description',
        orderDirection: Direction.Asc,
      };
    },
  },
  fragment,
  screenReference: 'PURCHASE_COST',
};

export default PurchaseCostTemplate;
